import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material"
import { CLOSE_DLG_SERVICE_PLAN, UPDATE_PLAN, selectDialogSerivcePlan, selectServiceTimes } from "./reducer";
import { toPriceKRW } from "../util/CommonUtils";
import { getDayKey, getPlans } from "./functions";
import { convToDateFromYearMonthDate01 } from "../util/date";

const ServicePlanDialog = () => {

  const dispatch = useDispatch();

  const { open, menu } = useSelector(selectDialogSerivcePlan);

  const serviceTimes = useSelector(selectServiceTimes);

  const plans = useMemo(
    () => getPlans(serviceTimes, menu), 
    [serviceTimes, menu]
  );

  const [ value, setValue ] = useState(plans[0]?.id ?? 0);

  useEffect(() => {
    if (menu?.servicePlanId) {
      setValue(menu.servicePlanId);
    }
    else {
      setValue(plans[0]?.id);
    }
  }, [serviceTimes, menu]);

  const handleChange = (evt) => {
    setValue(evt.target.value);
  }

  const handleApply = () => {
    if (menu.servicePlanId !== value) {
      dispatch({
        type: UPDATE_PLAN,
        payload: {
          menu,
          servicePlanId: typeof value === 'string' ? parseInt(value) : value
        }
      });
    }
    dispatch({ type: CLOSE_DLG_SERVICE_PLAN });
  }

  const handleClose = () => {
    dispatch({ type: CLOSE_DLG_SERVICE_PLAN });
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="service-plan-dialog-title"
    >
      <DialogTitle id="service-plan-dialog-title">
        서비스 플랜 선택 - {menu?.menu.name}
      </DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          {/* <FormLabel component="legend">플랜</FormLabel> */}
          <RadioGroup name="planId" value={value} onChange={handleChange}>
            {plans.map(plan => (
              <FormControlLabel 
                key={plan.id}
                value={plan.id}
                control={<Radio />}
                label={presentPrice(plan)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          취소
        </Button>
        <Button onClick={handleApply} color="primary" autoFocus>
          적용
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ServicePlanDialog;

const presentPrice = (plan) => {
  if (plan.pricingModel === 'tiered') {
    return toPriceKRW(plan.tierPrice) + (plan.isDefault ? ' (기본 플랜)' : '');
  }
  else {
    return '상품 판매가 기준';
  }
}